import { FC, ReactNode } from "react";
import MediaBlock from "../blocks/MediaBlock";
import Typography from "../Typography";

type BeforeAfterProps = {
  sectionTitle: ReactNode;
  body: ReactNode;
  videoSrc: string;
  videoAlt: string;
};

// A real source video next to the clip Klap made from it. The body carries
// what the video shows, because crawlers and LLMs can't watch it.
const BeforeAfter: FC<BeforeAfterProps> = ({
  sectionTitle,
  body,
  videoSrc,
  videoAlt,
}) => {
  return (
    <section className="max-w-5xl px-3 md:px-12 mx-auto my-32 text-center">
      <Typography variant="h2" component="h2">
        {sectionTitle}
      </Typography>
      <Typography
        variant="body1"
        className="mt-8 text-slate-500 leading-relaxed max-w-3xl mx-auto"
      >
        {body}
      </Typography>
      <MediaBlock
        className="mt-12 w-full aspect-video shadow-2xl shadow-slate-300 ring-2 ring-slate-300/50 bg-slate-200 mx-auto"
        data={{ type: "video", src: videoSrc, alt: videoAlt }}
        aria-label={videoAlt}
      />
    </section>
  );
};

export default BeforeAfter;
